/**
 * Description: Test mock data
 * Author: Chris
 * CreateAt: 2021-02-17
 */

//   <ProductCartItem
//     defaultCounterContent={<span>5</span>}
//     showPrice
//     price={12.0}
//     currency={'HKD'}
//     secondCurrency={'RMB'}
//     secondPrice={13.0}
//     title={'Mario'}
//     desc={'Mario'}
//     imageUrl={
//       'https://image-uat.unifyxp.com/images/Product/8ac07265-af63-4471-a4aa-8f3ba947b0ee.png'
//     }
//   />;
const productList = [
  {
    name: '产品名称2最多1行，多余部分省略',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    rrp: 'HKD 2550.90',
    lp: 'HKD 1999.90',
    erp: 'RMB 1500.90',
    isMultiSKU: false,
    isSoldOut: false,
  },
  {
    name: '产品名称2最多1行，多余部分省略产品名称2最多1行，多余部分省略产品名称2最多1行，多余部分省略',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    rrp: 'HKD 2550.90',
    lp: 'HKD 1999.90',
    erp: 'RMB 1500.90',
    isMultiSKU: false,
    isSoldOut: false,
  },
  {
    name: '产品名称3最多1行，多余部分省略产品名称2最多1行，多余部分省略产品名称2最多1行，多余部分省略',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    rrp: 'HKD 2550.90',
    lp: 'HKD 1999.90',
    erp: 'RMB 1500.90',
    isMultiSKU: false,
    isSoldOut: false,
  },
  {
    name: '产品名称5最多1行，多余部分省略产品名称2最多1行，多余部分省略产品名称2最多1行，多余部分省略',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    rrp: 'HKD 2550.90',
    lp: 'HKD 1999.90',
    erp: 'RMB 1500.90',
    isMultiSKU: false,
    isSoldOut: false,
  },
];

const productGridData_Two = [
  {
    name: '产品名称两行情况，多余省略…',
    title: '产品名称两行情况，多余省略…',
    thumbnailUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    stockAvailable: 123,
    multiSku: false,
    secondCurrency: 'CNY', // exchange rate currency
    secondPrice: 1800, //  exchange rate price

    originalPrice: 2500, //RRP
    // firstPrice: 2000, //current price
    // firstCurrency: 'HKD', //current currency
    soldOut_i18n: '卖光了',
    comments: 4.8,

    cartIconOnTop: true,
    hideCartIcon: false,

    onNavigateToDetail: () => {
      console.log('go to new page');
    },
    onAddCart: () => {
      console.log('add to new cart');
    },
  },
  {
    name: '产品名称两行情况，多余省略…',
    title: '产品名称两行情况，多余省略…',
    thumbnailUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    stockAvailable: 123,
    multiSku: false,
    secondCurrency: 'CNY', // exchange rate currency
    secondPrice: 1800, //  exchange rate price

    originalPrice: 2500, //RRP
    // firstPrice: 2000, //current price
    // firstCurrency: 'HKD', //current currency
    soldOut_i18n: '卖光了',
    comments: 4.8,

    cartIconOnTop: true,
    hideCartIcon: false,

    onNavigateToDetail: () => {
      console.log('go to new page');
    },
    onAddCart: () => {
      console.log('add to new cart');
    },
  },
  {
    name: '产品名称两行情况，多余省略…',
    title: '产品名称两行情况，多余省略…',
    thumbnailUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    stockAvailable: 123,
    multiSku: false,
    secondCurrency: 'CNY', // exchange rate currency
    secondPrice: 1800, //  exchange rate price

    originalPrice: 2500, //RRP
    // firstPrice: 2000, //current price
    // firstCurrency: 'HKD', //current currency
    soldOut_i18n: '卖光了',
    comments: 4.8,

    cartIconOnTop: true,
    hideCartIcon: false,

    onNavigateToDetail: () => {
      console.log('go to new page');
    },
    onAddCart: () => {
      console.log('add to new cart');
    },
  },
  {
    name: '产品名称两行情况，多余省略…',
    title: '产品名称两行情况，多余省略…',
    thumbnailUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    stockAvailable: 123,
    multiSku: false,
    secondCurrency: 'CNY', // exchange rate currency
    secondPrice: 1800, //  exchange rate price

    originalPrice: 2500, //RRP
    // firstPrice: 2000, //current price
    // firstCurrency: 'HKD', //current currency
    soldOut_i18n: '卖光了',
    comments: 4.8,
    cartIconOnTop: true,
    hideCartIcon: false,

    onNavigateToDetail: () => {
      console.log('go to new page');
    },
    onAddCart: () => {
      console.log('add to new cart');
    },
  },
];

const productGridData_Three = [
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
  {
    title: '产品名称两行情况，多余省略…',
    imageUrl: 'https://img95.699pic.com/photo/40188/6991.jpg_wh300.jpg',
    soldOut: false,
    multiSku: false,
    firstPrice: 2000, //current price
    firstCurrency: 'HKD', //current currency
    secondPrice: 1800, //  exchange rate price
    secondCurrency: 'CNY', // exchange rate currency
    originalPrice: 2500, //RRP
    rate: 4,
    comments: 4.8,
    soldOut_i18n: '卖光了',
    cartIconOnTop: true,
    hideCartIcon: false,
    // onNavigateToDetail: () => {
    //     console.log('go to new page');
    // },
    // onAddCart: () => {
    //     console.log('add to new cart');
    // },
  },
];

const goodsQuantity = 7;

const productCarouselImages = [
  'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
  'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
  'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
  'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
  'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
];

const productInformation = {
  title:
    '产品名称超长需要换行时多行产品名的情况还不够长吗？产品名称超长需要换行时多行产品名的情况还不够长吗？',
  subTitle: '产品相关小标题二十字内',
  rrp: 'HKD 2515.50',
  lp: 'HKD 1990.90',
  erp: '约 RMB 1599.90',
  isSoldOut: false,
  stockAmount: 10,
  skuData: {
    title: '请选择分类',
    skus: [
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 0,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 0,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
      {
        quantity: 1,
        url: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
      },
    ],
  },
};

const productIntroduction = {
  text: '意白時型医所権議位近救教賛問適合消勲。会裏逮気整破込海穂衛際月企年時，前千左家筋女来恵紀知戦明掲。経力形芸由芸者体革歩外後織著顧場。',
  images: [
    'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
    'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
    'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
    'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
    'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
    'https://s3-ap-southeast-1.amazonaws.com/tz-mag-media/wp-content/uploads/2018/07/30135440/image303.jpg',
  ],
};

export {
  productList,
  productGridData_Two,
  productGridData_Three,
  productCarouselImages,
  productInformation,
  productIntroduction,
  goodsQuantity,
};
